import { create } from "zustand";
import { createSelectors } from "../createSelectors";

interface CashdeskStoreState {
  isOpen: boolean;

  onOpen: () => void;
  onClose: () => void;
}

const cashdeskStore = create<CashdeskStoreState>((set) => ({
  isOpen: false,

  onOpen: () => set({ isOpen: true }),
  onClose: () => set({ isOpen: false }),
}));

export const useCashdeskStore = createSelectors(cashdeskStore);
